<template>
  <Card v-if="proxyPerson">
    <template slot="header">Change User's Group</template>
    <v-select
      v-model="selectedGroup"
      :items="personGroups"
      item-text="personGroupName"
      item-value="personGroupID"
    />
    <v-btn
      @click="changePersonGroup({personGroupID:selectedGroup})"
    >
      Save
    </v-btn>
  </Card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Group',
  data () {
    return {
      selectedGroup: 1
    }
  },
  computed: {
    ...mapGetters({
      proxyPerson: 'person/proxyPerson',
      personGroups: 'person/personGroups'
    })
  },
  mounted () {
    this.selectedGroup = this.proxyPerson.personGroupID
    this.getPersonGroups()
  },
  methods: {
    ...mapActions({
      getPersonGroups: 'person/getPersonGroups',
      changePersonGroup: 'person/changePersonGroup'
    })
  }
}
</script>
